<template>
  <div class="container-fluid">
    <div class="row fme-new-edit__title fme-montserrat-font">
      <div class="col-md-9">
        <h3>
          {{
            $t(`supervision.crud.page.${crudCurrentPageTitle}`) | textUpperCase
          }}
        </h3>
      </div>

      <div class="col-md-3 fme-new-edit__buttons text-right">
        <BaseButtonEvent
          :btText="$t('supervision.crud.button.goBack')"
          btClickType="goBack"
          btId="newEditeGoBack"
          btClickValue=""
          btUrlGoBack="CrudChecklistListPage"
          btCss="btn fme-btn fme-btn-secondary"
        />

        <span v-if="isUserAllowToEdit">
          <BaseButtonEvent
            v-if="checklistDeactivatedCrud === ''"
            :btText="$t('supervision.crud.button.disable')"
            btClickType="sendDelete"
            :btClickValue="id"
            btId="checklistDisableBt"
            :btUrlGo="urlDeactivate"
            btCss="btn fme-btn fme-btn-primary"
            btUrlGoBack="CrudChecklistListPage"
          />
          <BaseButtonEvent
            v-else
            :btText="$t('supervision.crud.button.enable')"
            btClickType="sendActivate"
            :btClickValue="id"
            btId="checklistActivateBt"
            :btUrlGo="urlActivate"
            btCss="btn fme-btn fme-btn-primary fme-btn-back"
          />
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 fme-checklist__name">
        <BaseInput
          :inputCurrentValue="checklistName"
          :inputTitle="$t('supervision.crud.form.checklist.name.title')"
          :inputPlaceholder="
            $t('supervision.crud.form.checklist.name.placeholder')
          "
          inputType="text"
          inputCss=""
          inputId="input-checklist-name"
          @returned-input-value="checklistInput('name', $event)"
          :inputErrorText="$t(checklistError.name)"
          :inputDisabled="!isUserAllowToEdit"
        />
      </div>
      <div class="col-md-6">
        <BaseInput
          v-if="isUserAllowToEdit"
          :inputCurrentValue="startInputTask"
          :inputTitle="$t('supervision.crud.form.checklist.task.title')"
          :inputPlaceholder="
            $t('supervision.crud.form.checklist.task.placeholder')
          "
          inputType="text"
          inputCss=""
          inputId="input-checklist-task"
          @returned-input-value="checklistInput('newTask', $event)"
          :inputErrorText="$t(checklistError.tasks)"
          :inputClear="true"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <ul class="fme-unordered-list__ul">
          <BaseUnorderedListDobleClickOneValues
            v-for="(item, index) in checklistTasks"
            :key="index"
            :value="item"
            :index="index"
            :urlUpdate="urlUpdateTask"
            :urlDelete="urlDeleteTask"
            :length="checklistTasks.length"
            :isAllowToEdit="isUserAllowToEdit"
            @returned-unorderedlist-value="updateTaskText($event)"
            @returned-unorderedlist-remove-value="deleteTask($event)"
            @returned-update-kind="updateTaskKind($event)"
          />
        </ul>
      </div>
    </div>

    <div v-if="isUserAllowToEdit" class="row fme-new-edit__row--last text-right">
      <div class="col-md-12">
        <BaseButtonEvent
          :btText="$t('supervision.crud.button.save')"
          :btClickType="saveValues.type"
          :btClickValue="newChecklist"
          :btId="saveValues.id"
          :btUrlGo="saveValues.urlGo"
          :btUrlGoBack="saveValues.urlBack"
          btCss="btn fme-btn fme-btn-primary"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { fetchFeatureToggles } from '../../../../services/featureToggler';
import { checkIfUserIsAllowToEdit } from '../../../../utils/checkIfUserIsAllowToEdit';
import { getV3Token } from '../../../../utils/getV3Token'; 
import { getUserRole } from '../../../../utils/getUserRole'; 

import axios from "axios";

const BaseInput = () => import("@/components/fragment/input/BaseInputOnlyBlur");
const BaseButtonEvent = () =>
  import("@/components/fragment/button/BaseButtonEvent");
const BaseUnorderedListDobleClickOneValues = () =>
  import("@/components/fragment/list/BaseUnorderedListDobleClickOneValues");

export default {
  name: "NewPage",
  async created() {
    this.clearStore();
    this.hasChecklist();
    this.changeCrudCurrentPageTitle("checklist");
    await this.getFeatures();
    this.checkUserPermissions();
  },
  update() {
    this.hasChecklist();
  },
  beforeDestroy() {
    this.clearStore();
    this.changeErrors([]);
  },
  data() {
    return {
      saveValues: {
        type: "sendPut",
        id: "btUpdateChecklist",
        urlGo: `${process.env.VUE_APP_CHECKLISTS_API}/${this.id}`,
        urlBack: "CrudChecklistListPage",
      },
      checklistError: {
        name: "",
        tasks: "",
      },
      startInputTask: "",
      isUserAllowToEdit: false
    };
  },
  props: {
    id: {
      type: String,
    },
  },
  components: {
    BaseInput,
    BaseButtonEvent,
    BaseUnorderedListDobleClickOneValues,
  },
  computed: {
    ...mapGetters(["axiosHeaders1"]),
    ...mapGetters("ModuleErrors", ["errorsList"]),
    ...mapGetters("ModuleSupervision", [
      "checklisttIdCrud",
      "checklistNameCrud",
      "checklistTasksCrud",
      "checklistDeactivatedCrud",
      "crudCurrentPageTitle",
    ]),
    checklistId() {
      return this.checklisttIdCrud;
    },
    checklistName() {
      return this.checklistNameCrud;
    },
    checklistTasks() {
      return this.checklistTasksCrud;
    },
    newChecklist() {
      let checklist = {
        name: this.checklistNameCrud,
      };

      return checklist;
    },
    urlActivate() {
      return `${process.env.VUE_APP_CHECKLISTS_API}/${this.id}/activate`;
    },
    urlDeactivate() {
      return `${process.env.VUE_APP_CHECKLISTS_API}/${this.id}/deactivate`;
    },
    urlUpdateTask() {
      return `${process.env.VUE_APP_CHECKLISTS_API}/${this.id}/tasks`;
    },
    urlDeleteTask() {
      return `${process.env.VUE_APP_CHECKLISTS_API}/${this.id}/tasks`;
    },
    urlCreateNewTask() {
      return `${process.env.VUE_APP_CHECKLISTS_API}/${this.id}/tasks`;
    },
  },
  methods: {
    ...mapActions("ModuleErrors", ["changeErrors"]),
    ...mapActions("ModuleSupervision", [
      "changeChecklistIdCrud",
      "changeChecklistNameCrud",
      "changeEditChecklistTasksCrud",
      "changeKindChecklistTask",
      "changeNewChecklistTasksCrud",
      "clearChecklistTasksCrud",
      "changeChecklistDeactivatedCrud",
      "changeCrudCurrentPageTitle",
      "changeChecklistSpecificTaskNameCrud",
      "removeChecklistSpecificTaskListCrud",
    ]),
    hasChecklist() {
      if (this.id !== "" && !isNaN(this.id)) {
        let url = `${process.env.VUE_APP_CHECKLISTS_API}/${this.id}?fields=id,name,created_at,deactivated_at,updated_at&status=all&eager=[tasks]`;

        axios
          .get(url, {
            headers: this.axiosHeaders1,
          })
          .then((response) => {
            return response.data.data;
          })
          .then((checklist) => {
            if (checklist.deactivated_at !== "") {
              this.$router.push({ name: "CrudChecklistListPage" });
            } else {
              this.setChecklist(checklist);
            }
          })
          .catch((e) => {
            if (e.response.status && e.response.status === 401) {
              this.logoutUser();
            } else {
              console.log(e);
            }
          });
      } else {
        this.$router.push({ name: "CrudChecklistListPage" });
      }
    },
    setChecklist(checklist) {
      this.changeChecklistIdCrud(checklist.id);
      this.changeChecklistNameCrud(checklist.name);
      this.changeEditChecklistTasksCrud(checklist.tasks);
      this.changeChecklistDeactivatedCrud(checklist.deactivated_at);
    },
    checklistInput(refValue, eventValue) {
      if (refValue === "name") {
        this.changeChecklistNameCrud(eventValue);
      } else if (refValue === "task") {
        if (refValue !== undefined || refValue !== "") {
          this.changeNewChecklistTasksCrud(eventValue);
        }
      } else if (refValue === "newTask") {
        let newUrl = this.urlCreateNewTask;
        let item = {
          name: eventValue,
          kind: this.checklistTasks.length,
        };
        axios
          .post(newUrl, item, {
            headers: this.axiosHeaders1,
          })
          .then((response) => {
            this.getNewTaskLits();
          })
          .catch((e) => {
            if (e.response.status && e.response.status === 401) {
              this.logoutUser();
            } else {
              console.log(e);
            }
          });
      }
    },
    clearStore() {
      this.changeChecklistNameCrud("");
      this.clearChecklistTasksCrud();
      this.changeChecklistDeactivatedCrud("");
    },
    updateTaskText(eventValue) {
      this.changeChecklistSpecificTaskNameCrud(eventValue);
    },
    deleteTask(eventValue) {
      this.removeChecklistSpecificTaskListCrud(eventValue);
    },
    getNewTaskLits() {
      let url = `${process.env.VUE_APP_CHECKLISTS_API}/${this.id}?fields=id,name,created_at,deactivated_at,updated_at&status=all&eager=[tasks]`;

      axios
        .get(url, {
          headers: this.axiosHeaders1,
        })
        .then((response) => {
          return response.data.data;
        })
        .then((checklist) => {
          this.clearChecklistTasksCrud();

          if (this.isReallyEmpty(checklist)) {
            this.$router.push({ name: "CrudChecklistListPage" });
          } else {
            this.changeEditChecklistTasksCrud(checklist.tasks);
          }
        })
        .catch((e) => {
          if (e.response.status && e.response.status === 401) {
            this.logoutUser();
          } else {
            console.log(e);
          }
        });
    },
    updateTaskKind(event) {
      this.changeKindChecklistTask(event);
    },
    async getFeatures() {
      try {
        const response = await fetchFeatureToggles(getV3Token());
        this.features = response;
      } catch (error) {
        console.error(error);
      }
    },
    checkUserPermissions() {
      if (this.features) {
        this.isUserAllowToEdit = checkIfUserIsAllowToEdit(this.features, getUserRole());
      } else {
        console.error("Features are not available yet.");
      }
    }
  },
  filters: {},
  watch: {
    errorsList() {
      this.checklistError.name = "";
      this.checklistError.tasks = "";

      if (this.hasProperty(this.errorsList.errors, "name")) {
        this.checklistError.name = `errors.name.${this.errorsList.errors.name[0].keyword}`;
      }

      if (this.hasProperty(this.errorsList.errors, "task")) {
        this.checklistError.tasks = `errors.tasks.${this.errorsList.errors.task[0].keyword}`;
      }
    },
    checklistTasks() {
      const promises = this.checklistTasks.map((item, index) => {
        axios.put(
          `${this.urlUpdateTask}/${item.id}`,
          {
            id: item.id,
            name: item.name,
            kind: index,
          },
          {
            headers: this.axiosHeaders1,
          }
        );
      });

      Promise.all(promises);
    },
  },
};
</script>

<style lang="scss">
.fme-checklist__name {
  // padding-top: 28px;
}
.fme-unordered-list__ul {
  list-style-type: none;
  padding-left: 14px;
}
</style>
